module.exports = __webpack_public_path__ + "evenemang/uppsala/static/media/vad-hander-logo.8465e6a6.svg";